<div class="quote-container">
  <ng-container *ngFor="let quote of data; let i = index">
    <div *ngIf="i === quoteIndex">
      <p class="quote">"{{ quote.quote }}"</p>
      <p class="source">{{ quote.src }}</p>
    </div>
  </ng-container>
</div>
